import React from 'react';

interface StatusIconProps {
  value: boolean | string | undefined;
  trueClassName?: string;
  falseClassName?: string;
  style?: React.CSSProperties;
}

const StatusIcon: React.FC<StatusIconProps> = ({
  value,
  trueClassName = 'ki-duotone ki-check-circle text-success fs-2',
  falseClassName = 'ki-duotone ki-cross-circle text-danger fs-2',
  style = { marginLeft: 20 },
}) => {
  // Accepts boolean or 'Yes'/'No' string
  const isTrue = value === true || value === 'Yes';
  return (
    <span className={isTrue ? trueClassName : falseClassName} style={style}>
      <span className="path1"></span>
      <span className="path2"></span>
    </span>
  );
};

export default StatusIcon;